export const CANONICAL_ORIGIN = "https://dulanstar-guesthouse.com";
export const BOOKING_URL =
  "https://www.booking-owlnest.com/03556e48-900d-4c5f-afc1-5d9989508862?lang=zh_TW&adult=1&child=0&infant=0";

export type NavItem = { href: string; zh: string; en: string };
export type PageMeta = {
  path: string;
  title: string;
  description: string;
  lang?: "zh-Hant" | "en";
  noindex?: boolean;
  canonicalPath?: string;
};

export const navigation: NavItem[] = [
  { href: "/rooms", zh: "房間", en: "Rooms" },
  { href: "/facilities", zh: "設施", en: "Facilities" },
  { href: "/direction", zh: "交通", en: "Direction" },
  { href: "/life-in-dulan", zh: "都蘭生活", en: "Life in Dulan" },
  { href: "/full-property-rental", zh: "包棟", en: "Full Property Rental" },
  { href: "/joinus", zh: "招募", en: "Join Us" },
];

export const indexablePaths = [
  "/",
  "/events",
  "/rooms",
  "/facilities",
  "/direction",
  "/getting-to-taitung",
  "/life-in-dulan",
  "/full-property-rental",
  "/joinus",
  "/joinus-en",
  "/application",
  "/workforstay",
] as const;

export const allPaths = [
  ...indexablePaths,
  "/privacy",
  "/reportpage",
  "/guest-feedback",
  "/guest-house-info",
  "/timetable",
  "/timetable-mobile",
  "/preview/home-image-band-video",
  "/preview/home-image-band",
  "/preview/home-hero-video",
] as const;

export const pageMeta: Record<string, PageMeta> = {
  "/": {
    path: "/",
    title: "都蘭小星民宿 Dulan Star Guest House",
    description:
      "都蘭小星民宿位於台東東海岸，提供舒適自在的住宿體驗，讓旅人療癒身心，並與在地人文和自然環境緊密連結。",
  },
  "/preview/home-image-band-video": {
    path: "/preview/home-image-band-video",
    title: "首頁橫幅影片預覽 — 都蘭小星民宿",
    description: "都蘭小星民宿首頁 image band 影片呈現方式的暫時預覽。",
    noindex: true,
    canonicalPath: "/",
  },
  "/preview/home-hero-video": {
    path: "/preview/home-hero-video",
    title: "首頁主視覺影片預覽 — 都蘭小星民宿",
    description: "都蘭小星民宿首頁 hero 影片呈現方式的暫時預覽。",
    noindex: true,
    canonicalPath: "/",
  },
  "/preview/home-image-band": {
    path: "/preview/home-image-band",
    title: "首頁原始圖片版預覽 — 都蘭小星民宿",
    description: "都蘭小星民宿首頁原始 image-band 圖片版，供內部比較。",
    noindex: true,
    canonicalPath: "/",
  },
  "/events": {
    path: "/events",
    title: "台東活動 Events | Discover Taitung — 都蘭小星民宿",
    description:
      "探索月光海、台東光祭、池上秋收、衝浪公開賽、慢食臺東及原住民族音樂節等台東年度活動。",
  },
  "/rooms": {
    path: "/rooms",
    title: "房間 Rooms | Book Your Dulan Stay Today — 都蘭小星民宿",
    description:
      "Explore Dulan Star Guest House rooms, including dorms and suites with modern amenities in Dulan, Taiwan.",
  },
  "/facilities": {
    path: "/facilities",
    title: "設施 Facilities | Experience Comfort Today — 都蘭小星民宿",
    description:
      "Discover free WiFi, bicycles, communal spaces and a shared kitchen at Dulan Star Guest House.",
  },
  "/guest-house-info": {
    path: "/guest-house-info",
    title: "民宿資訊 Guest House Info | 入住須知 — 都蘭小星民宿",
    description:
      "查看都蘭小星民宿入住退房時間、WiFi、廚房與洗衣設備、公共空間使用、海邊安全及都蘭生活提醒。",
    noindex: true,
  },
  "/direction": {
    path: "/direction",
    title: "交通 Direction | Plan Your Visit Today — 都蘭小星民宿",
    description:
      "Find driving and public transportation directions to Dulan Star Guest House in Taitung.",
  },
  "/getting-to-taitung": {
    path: "/getting-to-taitung",
    title: "如何到台東 Getting to Taitung — 都蘭小星民宿",
    description:
      "整理搭臺鐵、飛機、自行開車與長途客運抵達台東的交通方式，再接續前往都蘭小星。",
  },
  "/life-in-dulan": {
    path: "/life-in-dulan",
    title: "都蘭生活 Life in Dulan | Explore Dulan Today — 都蘭小星民宿",
    description:
      "Experience Dulan local culture, food, outdoor activities and unique East Coast experiences.",
  },
  "/full-property-rental": {
    path: "/full-property-rental",
    title: "Property Rental — 都蘭小星民宿 Dulan Star Guest House",
    description:
      "小星民宿包棟可容納16人，4人一間，皆為眠豆腐單人床，讓每個人都好睏。",
  },
  "/joinus": {
    path: "/joinus",
    title: "招募 Join Us | Join Our Team — 都蘭小星民宿",
    description: "加入都蘭小星民宿團隊，體驗真誠款待、文化交流與都蘭生活。",
  },
  "/joinus-en": {
    path: "/joinus-en",
    title:
      "Hiring English page | Join Our Hospitality Team Today — Dulan Star Guest House",
    description:
      "Join the team at Dulan Star Guest House and grow through hospitality, cultural exchange and life in Dulan.",
    lang: "en",
  },
  "/application": {
    path: "/application",
    title: "招募申請-職缺 | Join Our Team Today — 都蘭小星民宿",
    description:
      "Apply for a position at Dulan Star Guest House and become part of our welcoming community.",
  },
  "/workforstay": {
    path: "/workforstay",
    title: "打工換宿申請 | Join & Experience Dulan — 都蘭小星民宿",
    description:
      "Apply for the Dulan Star Guest House work-for-stay program and experience life on Taiwan’s East Coast.",
  },
  "/timetable": {
    path: "/timetable",
    title: "公車時刻表 | Plan Your Trip Now — 都蘭小星民宿",
    description: "台東火車站、台東市區與都蘭之間的公車時刻參考。",
    noindex: true,
    canonicalPath: "/direction",
  },
  "/timetable-mobile": {
    path: "/timetable-mobile",
    title: "手機版公車時刻表 — 都蘭小星民宿",
    description: "台東市區、台東火車站與都蘭之間的手機版公車時刻表。",
    noindex: true,
    canonicalPath: "/direction",
  },
  "/reportpage": {
    path: "/reportpage",
    title: "入住時間與匯款回報 Arrival Information — 都蘭小星民宿",
    description:
      "回報預計抵達都蘭小星的時間；如有匯款資訊也可一併提供，方便我們核對。",
    noindex: true,
  },
  "/guest-feedback": {
    path: "/guest-feedback",
    title: "住宿體驗回饋 Guest Feedback — 都蘭小星民宿",
    description:
      "Share your Dulan Star Guest House stay experience privately or anonymously.",
    noindex: true,
  },
  "/privacy": {
    path: "/privacy",
    title: "個人資料蒐集告知 — 都蘭小星民宿",
    description:
      "了解都蘭小星民宿如何蒐集、使用及保護表單資料，以及如何聯繫我們行使個人資料權利。",
    noindex: true,
  },
};

export const DULAN_STAR_PLACE_ID = "ChIJ5Yd3_YujbzQRY7wz9d0iYvs";

export const contact = {
  phone: "+88689530132",
  email: "hello@dulanstar-guesthouse.com",
  line: "https://line.me/R/ti/p/@804tkojq",
  phoneDisplay: "(089)530-132",
  lineId: "@804tkojq",
  instagram: "https://www.instagram.com/dulanstarguesthouse/",
  facebook: "https://www.facebook.com/dulanstar/",
  placeId: DULAN_STAR_PLACE_ID,
  map: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("都蘭小星民宿 Dulan Star Guest House")}&query_place_id=${DULAN_STAR_PLACE_ID}`,
  coordinates: { latitude: 22.8715293, longitude: 121.2233331 },
};

export const image = (name: string, width = 1280) =>
  `/images/${name}-${width}.webp`;

export const events = [
  {
    title: "Challenge Taiwan 國際鐵人三項賽",
    en: "Challenge Taiwan",
    date: "4月 | April",
    image: "event-challenge",
    description:
      "亞太地區具代表性的鐵人三項賽事，每年吸引大量國內外選手與家庭齊聚臺東完成挑戰。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6263",
    cta: "DETAILS",
  },
  {
    title: "月光・海音樂會",
    en: "Moonlit Sea Concert",
    date: "6~10月 | June – October",
    image: "event-moon",
    description:
      "以自然景觀做為舞台背景，月升日落、浪起潮退的動態展演，呈現東海岸生活的美學風格。",
    href: "https://www.eastcoast-nsa.gov.tw/zh-tw/event/activity/5777/",
    cta: "DETAILS",
  },
  {
    title: "台東最美星空系列活動",
    en: "Taitung Starry Night Series",
    date: "6~8月 | June – August",
    image: "event-starry-night",
    description:
      "以夜間觀星為主軸，搭配巡迴各鄉鎮的音樂會與星空體驗，讓海邊、縱谷與離島成為夜間舞台。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6264",
    cta: "DETAILS",
  },
  {
    title: "台東光祭",
    en: "Taitung Light Festival",
    date: "6~7月 | June – July",
    image: "event-light",
    description:
      "走進藝術作品，以當代手法呈現在地元素，讓聲光藝術陪伴人們回到再出發的起點。",
    href: "https://www.facebook.com/TaitungLightFestival/",
    cta: "DETAILS",
  },
  {
    title: "臺灣國際熱氣球嘉年華",
    en: "Taiwan International Balloon Festival",
    date: "7~8月 | July – August",
    image: "event-balloon",
    description:
      "臺東最具代表性的夏季品牌活動，在鹿野高台欣賞熱氣球升空、造型球展演、繫留體驗與光雕音樂會。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6269",
    cta: "DETAILS",
  },
  {
    title: "慢食臺東",
    en: "Slow Food Taitung",
    date: "11月 | November",
    image: "event-slow-food",
    description:
      "坐擁產地糧倉、多元族群與豐富飲食文化，臺東慢食有著令人迷醉的鮮活滋味。",
    href: "https://slowfoodtaitung.tw/",
    cta: "CLICK HERE",
  },
  {
    title: "南迴藝術季",
    en: "South Link Arts Festival",
    date: "7~11月 | July – November",
    image: "event-south-link",
    description:
      "沿著南迴公路展開的無圍牆美術館，以公共藝術與文化走讀回應山林、流域、海洋和部落生活。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6274",
    cta: "DETAILS",
  },
  {
    title: "臺東藝術節",
    en: "Taitung Arts Festival",
    date: "7~11月 | July – November",
    image: "event-taitung-arts",
    description:
      "跨越數月的縣級表演藝術季，涵蓋戲劇、音樂劇、音樂、歌仔戲、舞蹈與親子節目。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6277",
    cta: "DETAILS",
  },
  {
    title: "臺東藝穗節",
    en: "Taitung Fringe Festival",
    date: "7~8月 | July – August",
    image: "event-fringe",
    description:
      "以城市街區為舞台，在週末安排踩街、高空特技與當代馬戲，讓表演藝術走進日常空間。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6287",
    cta: "DETAILS",
  },
  {
    title: "2026 台東博覽會",
    en: "Taitung EXPO 2026",
    date: "夏季限定 | Summer Special",
    image: "event-expo",
    description:
      "2026 年特別大型城市策展，整合政府、在地產業、社區與文化行動，呈現臺東的地方價值與未來願景。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6281",
    cta: "DETAILS",
  },
  {
    title: "馬卡巴嗨藝術節",
    en: "Makapahay Arts Festival",
    date: "7~8月 | July – August",
    image: "event-makapahay",
    description:
      "以原住民族文化為核心，結合跨族群展演、青年舞台、部落美食、文創市集與城市參與。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/6217",
    cta: "DETAILS",
  },
  {
    title: "池上秋收稻穗藝術節",
    en: "Chishang’s Autumn Harvest Arts Festival",
    date: "10月 | October",
    image: "event-harvest",
    description: "遼闊「原」聲徜徉在稻浪中，華語、台語與原音跨越語言隔閡。",
    href: "https://www.facebook.com/Chishangarts.org",
    cta: "CLICK HERE",
  },
  {
    title: "阿米斯音樂節",
    en: "Amis Music Festival",
    date: "11月 | November",
    image: "event-amis",
    description:
      "兩年舉辦一次，以原民文化為主體的音樂節。慢慢起身，在自己的土地上長出自己的花。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/5958",
    cta: "DETAILS",
  },
  {
    title: "臺灣國際衝浪公開賽",
    en: "Taiwan Open of Surfing",
    date: "11月 | November",
    image: "event-surf",
    description: "世界各地的頂尖衝浪選手齊聚金樽，在東海岸秋冬浪季一較高下。",
    href: "https://www.taiwanopenofsurfing.org/",
    cta: "DETAILS",
  },
  {
    title: "原住民族國際音樂節",
    en: "Taiwan PASIWALI Festival",
    date: "12月 | December",
    image: "event-pasiwali",
    description:
      "PASIWALI 是阿美族語「往東方」的意思，一場跨越南島文化的部落音樂旅程。",
    href: "https://taiwanpasiwalifestival.com/",
    cta: "CLICK HERE",
  },
  {
    title: "台東跨年晚會",
    en: "Taitung New Year’s Eve Celebration",
    date: "12月底至1月初 | Late December – Early January",
    image: "event-new-year",
    description:
      "在臺東市國際地標或海濱公園周邊舉辦，結合大型舞台、重量級演出陣容與迎接新年的倒數活動。",
    href: "https://tour.taitung.gov.tw/zh-tw/event-calendar/details/5903",
    cta: "DETAILS",
  },
];

const homepageEventImages = [
  "event-moon",
  "event-light",
  "event-harvest",
  "event-amis",
  "event-surf",
  "event-slow-food",
  "event-pasiwali",
];

export const homepageEvents = homepageEventImages.map(
  (image) => events.find((event) => event.image === image)!,
);

export type SiteImage = {
  name: string;
  alt: string;
  width: number;
  height: number;
};

export const rooms = [
  {
    title: "四人混合宿舍房",
    en: "4-Bed Mixed Dorm",
    images: [
      {
        name: "room-mixed",
        alt: "四人混合宿舍房的床位與休息空間 4-Bed Mixed Dorm",
        width: 1332,
        height: 1332,
      },
    ],
    facts: [
      "房間尺寸 Room Size｜40 ㎡",
      "衛浴設備 Bathroom｜共用衛浴 Shared Bathroom",
      "每房人數 Capacity｜4 People",
      "床鋪大小 Bed Size｜97 × 195 cm",
      "眠豆腐床墊 Sleepy Tofu mattress / 床簾 Bed Curtain / 閱讀燈 Reading Light / 鎖櫃 Locker / 冷氣 AC",
    ],
  },
  {
    title: "四人女生上下舖套房｜附衛浴",
    en: "4-Bed Female Dorm Ensuite",
    images: [
      {
        name: "room-female",
        alt: "四人女生上下舖套房的床位 4-Bed Female Dorm Ensuite",
        width: 2240,
        height: 1680,
      },
    ],
    facts: [
      "房間尺寸 Room Size｜29 ㎡",
      "衛浴設備 Bathroom｜房內共用衛浴 Shared Bathroom (in the room)",
      "每房人數 Capacity｜4 People（訂四床可包房）",
      "床鋪大小 Bed Size｜105 × 188 cm",
      "眠豆腐床墊 Sleepy Tofu mattress / 床簾 Bed Curtain / 閱讀燈 Reading Light / 鎖櫃 Locker / 冷氣 AC",
    ],
  },
  {
    title: "四人套房附浴缸｜四張單人床",
    en: "Four-Person Suite with Bathtub",
    images: [
      {
        name: "room-suite",
        alt: "四張單人床與榻榻米座位區 Four-Person Suite",
        width: 2364,
        height: 1773,
      },
    ],
    facts: [
      "房間尺寸 Room Size｜35 ㎡",
      "衛浴設備 Bathroom｜私人衛浴 Private Bathroom",
      "每房人數 Capacity｜4 People",
      "床鋪大小 Bed Size｜97 × 195 cm × 4",
      "榻榻米座位區 Futon / 眠豆腐床墊 Sleepy Tofu mattress / 浴缸 Bathtub / 閱讀燈 Reading Light / 冷氣 AC",
    ],
  },
];

export const roomGallery: readonly SiteImage[] = [
  {
    name: "room-female",
    alt: "四人女生上下舖套房 4-Bed Female Dorm Ensuite",
    width: 2240,
    height: 1680,
  },
  {
    name: "gallery-mixed-1",
    alt: "四人混合宿舍房 4-Bed Mixed Dorm",
    width: 1332,
    height: 1332,
  },
  {
    name: "gallery-mixed-2",
    alt: "四人混合宿舍房的床位 4-Bed Mixed Dorm beds",
    width: 1024,
    height: 768,
  },
  {
    name: "gallery-mattress",
    alt: "全館採用的眠豆腐床墊 Mattresses used in every room",
    width: 1360,
    height: 1020,
  },
  {
    name: "gallery-suite",
    alt: "四人套房與榻榻米座位區 Four-Person Suite",
    width: 2364,
    height: 1773,
  },
  {
    name: "gallery-female-1",
    alt: "女生宿舍房床位 Female dorm beds",
    width: 1002,
    height: 1768,
  },
  {
    name: "gallery-female-2",
    alt: "女生宿舍房的上下舖 Female dorm bunk beds",
    width: 998,
    height: 1764,
  },
  {
    name: "gallery-female-3",
    alt: "女生宿舍房空間 Female dorm room",
    width: 1000,
    height: 1752,
  },
  {
    name: "gallery-washroom-1",
    alt: "明亮的共用衛浴 Shared washroom",
    width: 1536,
    height: 2048,
  },
  {
    name: "gallery-washroom-2",
    alt: "共用衛浴淋浴空間 Shared shower area",
    width: 1024,
    height: 768,
  },
  {
    name: "gallery-mixed-3",
    alt: "混合宿舍房內部 Mixed dorm interior",
    width: 576,
    height: 768,
  },
  {
    name: "gallery-mixed-4",
    alt: "混合宿舍房床位 Mixed dorm beds",
    width: 960,
    height: 1706,
  },
];

export type PlaceLink = { name: string; href: string; note?: string };
export type LifeGroup = { title: string; intro?: string; links: PlaceLink[] };

const place = (name: string, href: string, note?: string): PlaceLink => ({
  name,
  href,
  note,
});

export const lifeSections: Array<{
  title: string;
  en: string;
  groups: LifeGroup[];
}> = [
  {
    title: "吃・喝",
    en: "Food & Drinks",
    groups: [
      {
        title: "食物・Food",
        intro:
          "*營業時間請確認各店家官方公告 · Please check each store’s official info for hours.",
        links: [
          place(
            "店小二飯糰 Riceball Shop",
            "https://maps.app.goo.gl/iz9FbDAFjiaETGm8A",
          ),
          place(
            "素食早點 Vegetarian Breakfast Shop",
            "https://maps.app.goo.gl/koteCHE4S3KaEhks5",
          ),
          place("都蘭・小房子", "https://maps.app.goo.gl/hX9L6p7Xj41sU3n2A"),
          place(
            "江克白在花園 Bryce's Garden · Burgers",
            "https://maps.app.goo.gl/zMaJdgi185TYgFDv8",
          ),
          place(
            "江波 Jumpo Cuisine · Taco Place",
            "https://maps.app.goo.gl/MQ2ecmrVazoZjhV66",
          ),
          place(
            "Marge Kitchen · Filipino Food",
            "https://maps.app.goo.gl/zCL32PrBt5j9cBuS7",
          ),
          place(
            "都蘭研究所 Dulan Institute Of Creativity",
            "https://maps.app.goo.gl/hoDKqypYEiNBN9fD6",
          ),
          place("都蘭糖廠61餐館", "https://maps.app.goo.gl/4La3czawBybwZx4s8"),
          place("一刻館", "https://maps.app.goo.gl/RJgDSQyPB53C5FbE9"),
          place(
            "POOZ新蘭灣柴燒窯烤披薩",
            "https://maps.app.goo.gl/LRN9svscHRKfr3Bu8",
          ),
          place(
            "有間惦餐酒館 Hakka Mama Kitchen",
            "https://maps.app.goo.gl/VcB6NHyKNmhpJThA6",
          ),
          place("秋霞麵店", "https://maps.app.goo.gl/9CEupAJn2UXFv77JA"),
          place("哇哇哇大骨麵", "https://maps.app.goo.gl/nkeKHXGnxmL9NcTw5"),
          place(
            "都蘭・錦鸞越南美食",
            "https://maps.app.goo.gl/fsLXQrWGN5pKazNh6",
          ),
          place(
            "藝蔬咖食坊 kiso kiy'a",
            "https://maps.app.goo.gl/SFpBYRpCgxKvR8q4A",
          ),
          place(
            "都蘭海角咖啡 Dulan Cape Café",
            "https://maps.app.goo.gl/WtLaeNZEPR9P8Yj37",
          ),
          place(
            "都蘭院子大BBQ燒烤",
            "https://maps.app.goo.gl/nv798crcnMNTuvnE8",
          ),
          place("海人上菜", "https://maps.app.goo.gl/mPCyoV4kiAF82sNG7"),
          place(
            "享受不忙的片刻義式冰淇淋",
            "https://maps.app.goo.gl/kohEaGc3kc7hivQ26",
          ),
        ],
      },
      {
        title: "咖啡・Coffee",
        links: [
          place(
            "沙伯迪澳橄欖莊園 SOBDEALL",
            "https://maps.app.goo.gl/sxYSHXxP7nTMrmkp9",
          ),
          place("逗留豆遊", "https://maps.app.goo.gl/1xhRMCx98j4u28Jb6"),
          place(
            "達卡兒陶甕烘焙咖啡館",
            "https://maps.app.goo.gl/XMNvP8D5gVV93MWo7",
          ),
          place(
            "都蘭咖啡車廂 Coffeebox_Dulan",
            "https://maps.app.goo.gl/pdcXvVDT3WTKJJRU7",
          ),
          place(
            "晃輕鬆客棧咖啡館 Tranquilo",
            "https://maps.app.goo.gl/mbzoMhAxfFcs343Y6",
          ),
          place("珈琲小美", "https://maps.app.goo.gl/66ASRpFd1VuYdZpc6"),
          place(
            "MONDAY COFFEE&FOOD",
            "https://maps.app.goo.gl/SFLXboDe2mdyf1Xt8",
          ),
          place(
            "髒孩子工作室（肉桂捲專賣）",
            "https://maps.app.goo.gl/djb787QqQRhKdbxW7",
          ),
          place("我在玩-玩冰箱", "https://maps.app.goo.gl/VJgMXYt8EGYoSmQB7"),
        ],
      },
      {
        title: "酒吧・Bar",
        links: [
          place(
            "哇嘎哩共 Wagaligong",
            "https://maps.app.goo.gl/58qStzzwZ7BStk2C9",
          ),
          place(
            "台11 Highway11 Craft Beer",
            "https://maps.app.goo.gl/4istRtb3BzSLsipX7",
          ),
          place(
            "有海｜東岸露天酒吧",
            "https://maps.app.goo.gl/4vdem6n2ikRcBZ9J7",
          ),
        ],
      },
    ],
  },
  {
    title: "玩・樂",
    en: "Explore",
    groups: [
      {
        title: "當地市集・Markets",
        links: [
          place(
            "都蘭二手免廢市集 Dulan Flea Market",
            "https://www.facebook.com/dulanfleamarket/?locale=zh_TW",
          ),
        ],
      },
      {
        title: "戶外景點・Outdoor Places",
        intro: "*戶外活動有一定風險，請評估當日天候及自身狀況。",
        links: [
          place(
            "鉛橋海灘 Chien Chiao Beach",
            "https://maps.app.goo.gl/U3EnQ85Yp1snLD3e8",
          ),
          place(
            "加母子灣 Jiamuzi Bay",
            "https://maps.app.goo.gl/XSCFL2WXRtp3eFEa9",
          ),
          place(
            "杉原海灣 Shanyuan Bay",
            "https://maps.app.goo.gl/7vZsRrysjy5x3BGB8",
          ),
          place(
            "都蘭山登山步道 Dulan Mountain",
            "https://maps.app.goo.gl/bqYzrKc1QqoqAJGz8",
            "全程約需 5–7 小時",
          ),
          place(
            "七里溪 Qili Creek",
            "https://maps.app.goo.gl/9njt1UiXAKAUJhq87?g_st=il",
          ),
          place(
            "水往上流 Water Flows Up",
            "https://maps.app.goo.gl/XZnPbkQLWP5qUpwj6",
          ),
        ],
      },
      {
        title: "室內 / 展覽・Indoor Places / Exhibitions",
        links: [
          place(
            "女妖在說畫藝廊暨咖啡屋",
            "https://maps.app.goo.gl/FgtCtdQpyqaggN5D6",
          ),
          place(
            "'Etolan Style 都蘭國入境大廳",
            "https://maps.app.goo.gl/WKbdz3E3sV1oGFjN8",
          ),
          place(
            "都歷遊客中心 Duli Visitor Center",
            "https://maps.app.goo.gl/bFLkyxPXodF3hdt26",
          ),
          place(
            "國立臺灣史前文化博物館",
            "https://maps.app.goo.gl/gZT7vfTpKZDsDmkd9",
          ),
          place(
            "卑南遺址公園 Peinan Site Park",
            "https://maps.app.goo.gl/ARfgaXvrZTr6keMJA",
          ),
          place(
            "晃晃二手書店 Guesthouse Susu",
            "https://maps.app.goo.gl/tp8NaCHE57WvRvZ97",
          ),
        ],
      },
    ],
  },
  {
    title: "體・驗",
    en: "Experience",
    groups: [
      {
        title: "瑜珈・Yoga",
        links: [
          place("島嵎 l a b", "https://www.instagram.com/daoyu_yogalab/"),
          place(
            "SoulFun 收放療癒工作室",
            "https://www.instagram.com/soulfun.wellness",
          ),
        ],
      },
      {
        title: "按摩・Massage",
        links: [
          place(
            "牧伊椰子油按摩 Amui",
            "https://www.facebook.com/profile.php?id=100063756552678",
          ),
          place(
            "沐耳・專業採耳 / 撥筋",
            "https://www.facebook.com/groups/234520623560513/user/100083258706365/",
          ),
        ],
      },
      {
        title: "衝浪・Surfing",
        links: [
          place(
            "都蘭衝浪店 Doulan surf shop",
            "https://maps.app.goo.gl/iK89BWMxHt8o5QxN7",
          ),
          place(
            "哇軋力共 Wagaligong",
            "https://maps.app.goo.gl/WAvXZqm9jXYE38TJ6",
          ),
        ],
      },
      {
        title: "觀星・Stargazing",
        links: [
          place("小星民宿屋頂 The rooftop of our guest house", "#"),
          place("鉛橋海灘", "https://maps.app.goo.gl/U3EnQ85Yp1snLD3e8"),
          place(
            "月光小棧 Moonlight Inn",
            "https://maps.app.goo.gl/FgtCtdQpyqaggN5D6",
          ),
          place("加路蘭遊憩區", "https://maps.app.goo.gl/kDwetPPfsxLV3nmV6"),
          place(
            "報名觀星導覽",
            "https://www.facebook.com/profile.php?id=100067073154125&mibextid=LQQJ4d",
          ),
        ],
      },
      {
        title: "月光海・Moonlit Sea",
        intro:
          "滿月期間或前後幾天，日落後月光映照在海面上，就是美麗的月光海。The clearer the skies and the less light pollution, the more stunning the experience!",
        links: [],
      },
      {
        title: "手工肥皂・Soap Workshop",
        links: [
          place(
            "都蘭・足渡蘭 / 鄉村・裸製皂｜位置",
            "https://maps.app.goo.gl/sQCqCGaU4Sm3C7K1A",
          ),
          place("預約 Sign up", "https://9dulan.com/classes"),
        ],
      },
    ],
  },
];

export const facilityImages: readonly SiteImage[] = [
  {
    name: "facility-front",
    alt: "都蘭小星民宿入口 Dulan Star Guest House entrance",
    width: 1360,
    height: 1020,
  },
  {
    name: "facility-kitchen",
    alt: "共用廚房 Shared kitchen",
    width: 1536,
    height: 2048,
  },
  {
    name: "courtyard",
    alt: "半戶外庭院 Semi-outdoor courtyard",
    width: 1706,
    height: 960,
  },
  {
    name: "facility-patio",
    alt: "庭院休息區 Patio seating area",
    width: 959,
    height: 1705,
  },
  {
    name: "facility-living",
    alt: "室內公共空間 Indoor common area",
    width: 1890,
    height: 1372,
  },
  { name: "lounge", alt: "交誼廳 Lounge", width: 1024, height: 768 },
  {
    name: "facility-window",
    alt: "採光明亮的公共空間 Bright common area",
    width: 1360,
    height: 1020,
  },
  {
    name: "facility-mattress",
    alt: "眠豆腐床墊展示 Mattress display",
    width: 1360,
    height: 1020,
  },
  {
    name: "facility-decor",
    alt: "小星公共空間擺設 Common-area decor",
    width: 960,
    height: 1706,
  },
  {
    name: "facility-night",
    alt: "夜晚的都蘭小星 Dulan Star at night",
    width: 1080,
    height: 809,
  },
  {
    name: "facility-rooftop",
    alt: "可眺望山海的觀景天台 Rooftop with mountain and sea views",
    width: 1706,
    height: 960,
  },
];

export const timetableRoutes = [
  {
    href: "/timetable1",
    zh: "台東火車站 >> 都蘭",
    en: "Taitung Train Station >> Dulan",
  },
  { href: "/timetable2", zh: "台東市區 >> 都蘭", en: "Taitung City >> Dulan" },
  {
    href: "/timetable3",
    zh: "都蘭 >> 台東火車站",
    en: "Dulan >> Taitung Train Station",
  },
  { href: "/timetable4", zh: "都蘭 >> 台東市區", en: "Dulan >> Taitung City" },
];

export const timetableDetails: Record<
  string,
  { zh: string; en: string; stop?: string; times: Array<[string, string]> }
> = {
  "/timetable1": {
    zh: "台東火車站 >> 下都蘭",
    en: "Taitung Train Station >> Xiadulan",
    times: [
      ["08:05", "8101"],
      ["10:05", "8103"],
      ["10:55", "8109"],
      ["11:55", "8103"],
      ["12:45", "8101"],
      ["13:55", "8103"],
      ["14:45", "8109"],
      ["15:45", "8103"],
      ["16:25", "8109"],
      ["17:55", "8101"],
      ["18:55", "8109"],
      ["19:25", "8103"],
      ["21:15", "8103"],
    ],
  },
  "/timetable2": {
    zh: "台東轉運站 >> 下都蘭",
    en: "Taitung Bus Station >> Xiadulan",
    times: [
      ["06:30", "8119"],
      ["07:00", "8102"],
      ["07:40", "8101"],
      ["08:40", "8102"],
      ["09:40", "8103"],
      ["10:30", "8109"],
      ["10:40", "8120"],
      ["11:30", "8103"],
      ["12:20", "8101"],
      ["13:30", "8103"],
      ["14:20", "8109"],
      ["14:40", "8102"],
      ["15:20", "8103"],
      ["16:00", "8109"],
      ["16:10", "8120"],
      ["16:50", "8102"],
      ["17:30", "8101"],
      ["18:10", "8120"],
      ["18:30", "8109"],
      ["19:00", "8103"],
      ["20:50", "8103"],
    ],
  },
  "/timetable3": {
    zh: "下都蘭 >> 台東火車站",
    en: "Xiadulan >> Taitung Train Station",
    times: [
      ["07:16", "8103"],
      ["08:26", "8109"],
      ["10:21", "8101"],
      ["11:11", "8101"],
      ["12:51", "8103"],
      ["12:56", "8109"],
      ["13:36", "8103"],
      ["14:16", "8101"],
      ["16:26", "8101"],
      ["17:56", "8109"],
      ["18:06", "8101"],
      ["19:31", "8103"],
    ],
  },
  "/timetable4": {
    zh: "下都蘭 >> 台東轉運站",
    en: "Xiadulan >> Taitung Bus Station",
    times: [
      ["07:10", "8122"],
      ["07:16", "8103"],
      ["07:50", "8120"],
      ["08:26", "8109"],
      ["08:35", "8102"],
      ["09:35", "8102"],
      ["10:21", "8101"],
      ["11:11", "8101"],
      ["12:05", "8102"],
      ["12:51", "8103"],
      ["12:56", "8109"],
      ["13:36", "8103"],
      ["14:16", "8101"],
      ["15:30", "8102"],
      ["16:26", "8101"],
      ["17:40", "8119"],
      ["17:56", "8109"],
      ["18:06", "8101"],
      ["18:50", "8102"],
      ["19:31", "8103"],
      ["20:05", "8102"],
      ["20:35", "8120"],
    ],
  },
};
